import xhr from "../utils/fetch";

const getTransactions = async (
  currentPage: number,
  resultsPerPage: number,
  filters: any,
  sortBy: any
) => {
  return await xhr({
    url: `/a/user-transactions`,
    method: 'GET',
    params: {
      resultsPerPage: resultsPerPage.toString(),
      page: currentPage.toString(),
      ...filters,
      ...sortBy
    }
  })
    .then((res) => res.data)
    .catch((err) => err);
}


const earningsApi = {
  getTransactions
}
export default earningsApi;